<!--begin::footer-->
<div id="footer" class="footer py-1 d-flex flex-lg-column">
    <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
    <div class="text-dark col-md-12 col-sm-12 col-xs-12">
    <p class="main-p">{{content?.pageHeader}}</p>
        </div>
    </div>
    <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
        <div class="text-dark col-md-12 col-sm-12 col-xs-12">
            
            <img class="p-2" src="assets/images/icon-coke.png" style="width:65px">&nbsp;&nbsp;
            <a class="text-white" [routerLink]="['/setup/in/baseline-setup']">
                    {{content?.baselines}} : {{this.storage.totalBaseLine}}                
            </a>&nbsp;
            <span class="text-white">|</span>&nbsp;

            <a class="text-white" [routerLink]="['/setup/scen/simulation-setup']">
                {{content?.simulations}}  : {{this.storage.totalSimulation}}                
            </a>
        </div>
    </div>
</div>
<!--end::footer-->